import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M9.03897 6.44358L6.87188 8.77712M13.5812 1.02276C13.6498 0.997294 13.7236 0.993102 13.7942 1.01067C13.8649 1.02823 13.9295 1.06685 13.9808 1.1221C14.032 1.17736 14.0678 1.24701 14.084 1.32312C14.1002 1.39923 14.0962 1.47871 14.0724 1.55248L9.79312 14.7214C9.76752 14.8001 9.72053 14.8688 9.65827 14.9184C9.596 14.968 9.52132 14.9963 9.44393 14.9997C9.36653 15.003 9.28998 14.9812 9.22421 14.9372C9.15844 14.8931 9.10649 14.8288 9.07509 14.7525L6.7498 9.11937C6.71067 9.02569 6.64103 8.9507 6.55403 8.90857L1.32266 6.40391C1.25208 6.36998 1.19257 6.31403 1.15182 6.24331C1.11107 6.17258 1.09095 6.09033 1.09406 6.00716C1.09717 5.924 1.12337 5.84375 1.16927 5.77679C1.21517 5.70982 1.27867 5.65922 1.35155 5.63151L13.5812 1.02276Z",
		stroke: "#616161",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
